import React from "react";
import { Box, SimpleGrid, useColorMode } from "@chakra-ui/react";
import "./Projects.css";

import skinstoreproject from "../Images/skinstoreproject.png";
import shopall from "../Images/shopall.png";
import youtube from "../Images/youtube.png";
import glambgodess from "../Images/glambgodess.png";
import dream from "../Images/dreamHome.png"
import vastra from "../Images/vastra.png"
import admin from "../Images/admin_dashboard.png"
import { FaGithub, FaEye } from "react-icons/fa";

export const Projects = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <div
      id="projects"
      className="project_main_container"
      style={{
        backgroundColor: colorMode == "light" ? "#edf2f8" : "#1a202c",
      }}
    >
      <div className="project_container">
        <div className="project_heading">
          <h2>
            <span>My</span> Creative <span>Projects </span>
          </h2>
        </div>

        <div className="project_grid">
          <SimpleGrid columns={[1, 1, 2, 2]} spacing="40px" className="project_grid">
          <Box >
              <div
                // className="project_box"
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={vastra} alt="shopall" />
                </div>

                <div className="project-title">
                  <h2 >Vastra</h2>
                </div>
                <div className="project-description">
                  <p>Vastra is a one top shop for all your fashion and lifestyle needs. Being India's largest e-commerce store for fashion and lifestyle products.
                  </p>
                </div>
                <div className="project_tech_stack">
                  <h5>
                    <span>Tech Stack :</span> React, JavaScript, Redux, HTML, CSS, Chakra UI
                    React Icons
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="project-github-link">
                    <a
                      href="https://github.com/soniadiwedi/Myntra_clone"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div className="project-deployed-link">
                    <a
                      href="https://myntra-clone-zuwr.vercel.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>

            <Box>
              <div
                // className="project_box"
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={glambgodess} alt="tata1mg" />
                </div>

                <div className="project-title">
                  <h2 >Glamb Godess</h2>
                </div>
                <div className="project-description" >
                  <p >
                    Glamb Godess is an e-commerce web application that provides
                    beauty products all across India. This is a collaborative
                    project. This is a clone of Beauty Bebo. We have built in a
                    5 days
                  </p>
                </div>
                <div >
                  <h5>
                    <span className="project-tech-stack">Tech Stack :</span>{" "}
                    HTML,CSS,JavaScript
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="github_link">
                    <a
                      className="project-github-link"
                      href="https://github.com/soniadiwedi/-scary-flower-3406"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div className="deploy_link">
                    <a
                      className="project-deployed-link"
                      href="https://silly-crostata-613bb2.netlify.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>

            <Box >
              <div
               
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={skinstoreproject} alt="" />
                </div>

                <div className="project-title">
                  <h2>India Herbal Creation</h2>
                </div>
                <div className="project-description">
                  <p>
                    This website is a clone of "Skin Store" this is a individual
                    project I implimented some functionalities like login,
                    signup, product page, add single product page etc.
                  </p>
                </div>
                 <div className="project_tech_stack">
                  <h5>
                    <span  >Tech Stack :</span> HTML, CSS, JavaScript,
                    API, Icons
                   
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="project-github-link">
                    <a
                      className="project-github-link"
                      href="https://github.com/soniadiwedi/-needed-houses-3986"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div class="project-deployed-link">
                    <a
                      href="https://needed-houses-3986.vercel.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>

            <Box >
              <div
                // className="project_box"
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={admin} alt="shopall" />
                </div>

                <div className="project-title">
                  <h2 >Admin Dashboard</h2>
                </div>
                <div className="project-description">
                  <p>
                 Admin Dashboard
                  </p>
                </div>
                <div className="project_tech_stack">
                  <h5>
                    <span>Tech Stack :</span> Vite, TypeScript, Rechart , SCSS, Material ui
                    
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="project-github-link">
                    <a
                      href="https://github.com/soniadiwedi/Admin_Dashboard"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div className="project-deployed-link">
                    <a
                      href="https://admin-dashboard-mt8lbp1g4-soniadiwedi1998gmailcoms-projects.vercel.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>

            <Box >
              <div
                // className="project_box"
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={shopall} alt="shopall" />
                </div>

                <div className="project-title">
                  <h2 >ShopAll</h2>
                </div>
                <div className="project-description">
                  <p>
                    This website is a clone of "Skin Store" this is a individual
                    project I implimented some functionalities like login,
                    signup, product page, add single product page etc.
                  </p>
                </div>
                <div className="project_tech_stack">
                  <h5>
                    <span>Tech Stack :</span> React, JavaScript, Chakra UI, CSS,
                    React Icons
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="project-github-link">
                    <a
                      href="https://github.com/soniadiwedi/descriptive-dirt-2392/tree/main/shopall"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div className="project-deployed-link">
                    <a
                      href="https://descriptive-dirt-2392.vercel.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>
              
            <Box >
              <div
                // className="project_box"
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={youtube} alt="shopall" />
                </div>

                <div className="project-title">
                  <h2 >YouTube</h2>
                </div>
                <div className="project-description">
                  <p>It is clone of YouTube. It replicates key features of the original platform, providing a personalized feed, search functionality, and video recommendations.
                  </p>
                </div>
                <div className="project_tech_stack">
                  <h5>
                    <span>Tech Stack :</span> React, JavaScript, Tailwind CSS, CSS,
                    React Icons
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="project-github-link">
                    <a
                      href="https://github.com/soniadiwedi/youtubeclone"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div className="project-deployed-link">
                    <a
                      href="https://youtubeclone-mauve.vercel.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>

            <Box >
              <div
                className="project-card"
                style={{
                  backgroundColor: colorMode == "light" ? "white" : "#1a202c",
                }}
              >
                <div className="project_image">
                  <img src={dream} alt="dreamHome" />
                </div>

                <div className="project-title">
                  <h2 >DreamHome</h2>
                </div>
                <div className="project-description">
                  <p>It is website for purchasing our new dream house. Fully responsive.
                  </p>
                </div>
                <div className="project_tech_stack">
                  <h5>
                    <span>Tech Stack :</span> React, JavaScript, SCSS,
                    React Icons, React Leaflet
                  </h5>
                </div>
                <div className="project_icon">
                  <div className="project-github-link">
                    <a
                      href="https://github.com/soniadiwedi/DreamHome/tree/master"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaGithub />
                    </a>
                  </div>
                  <div className="project-deployed-link">
                    <a
                      href="https://dream-home-zeta.vercel.app/"
                      rel="noopener norefferer"
                      target="_blank"
                    >
                      <FaEye />
                    </a>
                  </div>
                </div>
              </div>
            </Box>
            

        

       

            
          </SimpleGrid>
        </div>
      </div>
    </div>
  );
};
